/// collapsable row
const productAccordions = document.querySelectorAll(".accordion");

//// facets
const facets = document.querySelectorAll(".facets__disclosure-vertical");
const facetsSummary = document.querySelector(".facets__summary");

//// sort options
const sortFacetTitle = document.querySelector(".facet-filters__title");
const radioButtonsContainer = document.querySelector(".radio-buttons");

if (facetsSummary && facets) {
  const initailFacetHeight = facetsSummary.clientHeight;
  const initailFacetHeightPx = initailFacetHeight + "px";

  //// facets
  facets.forEach((facet) => {
    facet.style.height = initailFacetHeightPx;
    const contentHeight = facet.querySelector(
      ".facets__display-vertical"
    ).clientHeight;
    if (facet.hasAttribute("open")) {
      facet.style.height = `${contentHeight + initailFacetHeight}px`;
    } else {
      facet.style.height = initailFacetHeightPx;
    }
    facet.addEventListener("click", (e) => {
      if (e.target.closest(".facets__display-vertical")) {
        e.stopPropagation();
        return;
      } else if (!facet.hasAttribute("open")) {
        facet.style.height = `${contentHeight + initailFacetHeight}px`;
      } else {
        facet.style.height = initailFacetHeightPx;
      }
    });
  });
}

const sortFacetForm = document.querySelector("#FacetSortForm");
// radioButtonsContainer shtine mrena clickit te sortfacettitle
if (sortFacetForm) {
  sortFacetForm.addEventListener("click", (e) => {
    let radioButtonsContainer = document.querySelector(".radio-buttons");
    if (e.target.closest(".facet-filters__title")) {
      if (radioButtonsContainer.clientHeight === 0) {
        radioButtonsContainer.style.height = "350px";
        sortFacetTitle.querySelector("svg").style.transform = "rotate(90deg)";
      } else {
        radioButtonsContainer.style.height = "0px";
        sortFacetTitle.querySelector("svg").style.transform = "rotate(0deg)";
      }
    }
  });
}

// sortFacetTitle.addEventListener("click", (e) => {
//   console.log("clicked!!", sortFacetTitle, e.target);
//   if (radioButtonsContainer.clientHeight === 0) {
//     radioButtonsContainer.style.height = "350px";
//     sortFacetTitle.querySelector("svg").style.transform = "rotate(90deg)";
//   } else {
//     radioButtonsContainer.style.height = "0px";
//     sortFacetTitle.querySelector("svg").style.transform = "rotate(0deg)";
//   }
// });

if (productAccordions) {
  productAccordions.forEach((productAccordion) => {
    const productAccordionTitle = productAccordion.querySelector("summary");
    const productAccordionContent = productAccordion.querySelector(
      ".accordion__content"
    );
    const productAccordionContentInitialHeight =
      productAccordionContent.clientHeight; // getting the height in order to preserve it for later use
    productAccordionContent.style.height = "0px"; // setting the height of the content 0 to then make it to initial height when we click

    productAccordionTitle.addEventListener("click", (e) => {
      if (!productAccordion.querySelector("details").hasAttribute("open")) {
        productAccordionContent.style.height = `${productAccordionContentInitialHeight}px`;
      } else {
        productAccordionContent.style.height = "0px";
      }
    });
  });
}

const customCollapsableRow = document.querySelectorAll(
  ".custom-collapsible-row"
);
if (customCollapsableRow) {
  customCollapsableRow.forEach((collapsibleRow) => {
    if (collapsibleRow.hasAttribute("open")) {
      const titleHeight = collapsibleRow.querySelector(
        ".custom-collapsible-row__title"
      ).clientHeight;

      const contentHeight = collapsibleRow.querySelector(
        ".custom-collapsible-row__content"
      ).clientHeight;
      console.log("sdadsasd", titleHeight + contentHeight);
      collapsibleRow.style.setProperty(
        "--row-height",
        `${titleHeight + contentHeight}px`
      );
    }
    collapsibleRow.addEventListener("click", (e) => {
      // Close other open collapsible rows
      const titleHeight = collapsibleRow.querySelector(
        ".custom-collapsible-row__title"
      ).clientHeight;

      const contentHeight = collapsibleRow.querySelector(
        ".custom-collapsible-row__content"
      ).clientHeight;
      document
        .querySelectorAll(".custom-collapsible-row[open]")
        .forEach((row) => {
          if (row !== collapsibleRow) {
            row.removeAttribute("open");
            row.style.setProperty("--row-height", `${titleHeight + 2}px`);
          }
        });

      if (e.target.closest(".custom-collapsible-row__title")) {
        if (collapsibleRow.hasAttribute("open")) {
          console.log("colalsdjas has attribute");
          collapsibleRow.removeAttribute("open");
          collapsibleRow.style.setProperty(
            "--row-height",
            `${titleHeight + 2}px`
          );
        } else {
          collapsibleRow.setAttribute("open", "");
          collapsibleRow.style.setProperty(
            "--row-height",
            `${titleHeight + contentHeight}px`
          );
        }
      } else {
        return;
      }
    });
  });
}
